import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-color-info',
  templateUrl: './color-info.component.html',
  styleUrl: './color-info.component.scss',
})
export class ColorInfoComponent {
  @Input() colorCode = '#971a1a';
}
